import { VColorPicker } from 'vuetify/lib/components/VColorPicker';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VColorPicker, {
    attrs: {
      "value": _vm.value,
      "dot-size": "25",
      "hide-canvas": "",
      "hide-sliders": "",
      "show-swatches": "",
      "hide-mode-switch": "",
      "swatches-max-height": "200",
      "mode": "hexa",
      "swatches": _vm.swatches
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue($event);
      }
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };